//Views
import Store from '@/views/Store/index'
import IndexStore from '@/views/Store/news'
import Vault from '@/views/Store/vault.vue'

const routes = [
    {
        path:'/mercado',
        name: 'store',
        component:Store,
        children: [
            {
                name:'index',
                path:'',
                component:IndexStore
            },
            {
                name:'baul',
                path:'baul',
                component:Vault
            },
        ],
        meta: {
          title: 'Mercado ༒ MUCRISIS',
          layout: 'default',
          metaTags: [
            {
              name: 'description',
              content: 'Compra y vende tus items de MU CRISIS a otros jugadores!'
            },
            {
              property: 'og:description',
              content: 'Compra y vende tus items de MU CRISIS a otros jugadores!'
            }
          ]
        }
      },
]

export default routes